import React, { useEffect } from "react";
import RoomSuitsList from "../components/RoomSuits/RoomSuitsList";
import MasonryGallery from "../components/Gallary/MasonaryGallary";
import { useAppDispatch, useAppSelector } from "../Hooks";
import { getRoomTypeData } from "../features/Room";
import { getGalleryData } from "../features/Gallery";
import { Loader } from "../components/common/Loader";
import { Banner } from "../components/common/Banner";

const RoomSuits: React.FC<{ banner_title: string }> = ({ banner_title }) => {
    const dispatch = useAppDispatch();
    const { room_types, roomLoader, status } = useAppSelector(state => state.room);
    const { room_gallery, galleryLoader, status: galleryStatus } = useAppSelector(state => state.gallery);

    const { menu } = useAppSelector(state => state.menuAccess);
    const { room_suits_sections } = menu?.room_suits || {};


    useEffect(() => {
        dispatch(getRoomTypeData());
        dispatch(getGalleryData());
    }, [status, galleryStatus, dispatch]);


    if (roomLoader || galleryLoader) {
        return <Loader />
    }

    return (
        <>

            <Banner banner_title={banner_title} />
            {
                room_suits_sections && room_suits_sections?.room_list &&

                <RoomSuitsList room_types={room_types} />
            }
            {
                room_suits_sections && room_suits_sections?.masonry_gallery &&

                <MasonryGallery images={room_gallery} />
            }
        </>

    )
}
export default RoomSuits;